import _ from 'lodash';
import { useRef } from 'react';

/**
 * Keeps a stable reference for a value that is structurally unchanged, so effects do not rerun on new object identities. Replaces the stored ref only when a lodash deep-equality check fails and returns the retained value.
 *
 * @param value - Value to compare deeply against the retained one.
 * @returns Retained value, replaced only when it deeply changed.
 */
const useDeepCompareMemoize = (value: any) => {
  const ref = useRef(value);
  if (!_.isEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
};

export default useDeepCompareMemoize;
